import { Component, OnInit } from '@angular/core';
import { DialogService } from 'primeng';

import { Router } from '@angular/router';
import { AccessUserInfo, UserDetail } from 'src/app/models';
import { LabRequestService } from 'src/app/services/water-lab/lab-request.service';
@Component({
  selector: 'bart-bottom-search',
  templateUrl: './bottom-search.component.html',
  styleUrls: ['./bottom-search.component.scss']
  
})
export class BottomSearchComponent implements OnInit {
  displayPosition: boolean;
  position: string;
  btnLabel:string;
  //---Defect Id: 12307 The close icone of all the 3 tabs are displayed only enable tab dram---
  public index: number;
  public showclose1:boolean=false;
  public showclose2:boolean=false;
  public showclose3:boolean=false;
  public bartRoleCode:string;
  isWaterLabSelect:boolean=false;
  constructor(private _router:Router,private _waterLabService :  LabRequestService) { 
    let userInfo:UserDetail = AccessUserInfo.getUserInfo();
    if(userInfo!=null)
    {
      this.bartRoleCode=userInfo.bartRoleCode
    }
  }
  ngOnInit() {
   console.log();
   
  }
  showPositionDialog(position: string,btnLabel:string) {
    this.position = position;
    this.displayPosition = true;
    this.btnLabel=btnLabel;
    if(btnLabel=="Ticket Search")
    {
      this.index = 0;
      this.showclose1=true;
      this.showclose2=false;
      this.showclose3=false;
    }
    if(btnLabel=="Resources Search")
    {
      this.index = 1;
      this.showclose1=false;
      this.showclose2=true;
      this.showclose3=false;
      this._waterLabService.pushValueFromHelp(false);
    }
    if(btnLabel=="Parts Search")
    {
      this.index = 2;
      this.showclose1=false;
      this.showclose2=false;
      this.showclose3=true;
    }
    
}
//------Defect Id: 12307 The close icone of all the 3 tabs are displayed only enable tab dram-----
handleClose(e) {
  this.displayPosition = false;
  this.index=1
  //e.close();
}
//---Defect Id: 12307 The close icone of all the 3 tabs are displayed only enable tab dram---
ticketsearch()
{
  this.showclose1=false;
  this.showclose2=false;
  this.showclose3=false;
if(this.index==0)
{
  this.showclose1=true;
}
else if(this.index==1)
{
  this.showclose2=true;
}
else if(this.index==2)
{
  this.showclose3=true;
}
}
//---Defect Id: 12307 The close icone of all the 3 tabs are displayed only enable tab dram---
public hasPermission()
  {
    let result:Boolean=false
    if("ADMIN,BOM,BSS,HHD,BSSX,BOMX".split(",").indexOf(this.bartRoleCode)>-1)
    {
      result= true;
      
    }
    if(this.isWaterLabSelect)
    {
      result=false;
    }
    return result
  }
  ngDoCheck()
  {
    this.isWaterLabSelect=false;
    if(this._router.url.toLowerCase().indexOf("waterlab")>-1 || this._router.url.toLowerCase().indexOf("labmanager")>-1)
    {
      this.isWaterLabSelect=true;
    }
    
  }
}
